import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const AlertIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.1504 1.58805C11.5242 0.871366 12.5498 0.871368 12.9236 1.58805L23.409 21.6892C23.7562 22.355 23.2732 23.1517 22.5223 23.1517H1.55164C0.800748 23.1517 0.317737 22.355 0.665018 21.6892L11.1504 1.58805ZM11.0257 8.99142H13.0482V17.083H11.0257V8.99142ZM13.0483 18.0945H11.0258V20.1174H13.0483V18.0945Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default AlertIcon
